 import { useDispatch, useSelector } from "react-redux";
   import "../styles/footer.css";
  import { FaFacebook } from "react-icons/fa";
  import { FaXTwitter } from "react-icons/fa6";
  import { FaInstagram } from "react-icons/fa6";
import { subscribeNewsletter } from "../features/user/userSlice";
import { useState } from "react";
import { MdNavigateNext } from "react-icons/md";
 import { MdOutlineEmail } from "react-icons/md";
import { MdLocalPhone } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { toast } from "react-toastify";


const Footer = () => {
 
  const [email, setEmail] = useState("");
  
  const dispatch = useDispatch();
  
 
     const handleSubscribe = (e) => {
 
      e.preventDefault();
    if (email) {
      dispatch(subscribeNewsletter(email));
      setEmail("");
      toast.success("Subscribed successfully!");
     }
  };
   
  

  return (
    <>
<footer>
  {/* Top Newsletter Section */}
  <div className="footer__top-strip">
    <div>
      <h2>Stay Updated</h2>
      <p className="sign-up-el">
        Subscribe to our newsletter for the latest car deals, tips, and updates.
      </p>
    </div>
    <form onSubmit={handleSubscribe} className="newsletter-form">
      <input
        type="email"
        className="form-control"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit" className="subscribe-btn">Subscribe</button>
    </form>
  </div>

  {/* Middle Links Section */}
  <div className="footer-mid-element">
    <div className="footer-col">
      <h4>About Us</h4>
      <p>
        We are committed to delivering quality vehicles and exceptional customer service. 
        Whether you’re buying, selling, or just exploring, we’re here for you.
      </p>
    </div>
    <div className="footer-col">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="/about-us"><MdNavigateNext className="navigate-icon"/> About Us</a></li>
        <li><a href="/vehicles"><MdNavigateNext className="navigate-icon"/> Cars for Sale</a></li>
        <li><a href="/blogs"><MdNavigateNext className="navigate-icon"/> Blog & Tips</a></li>
        <li><a href="/imports"><MdNavigateNext className="navigate-icon"/> Import With Us</a></li>
      </ul>
    </div>
    <div className="footer-col">
      <h4>Customer Support</h4>
      <ul>
        <li><a href="/faqs"><MdNavigateNext className="navigate-icon"/> FAQs</a></li>
         <li><a href="/terms-and-conditions"><MdNavigateNext className="navigate-icon"/> Terms & Conditions</a></li>
        <li><a href="/privacy-policy"><MdNavigateNext className="navigate-icon"/> Privacy Policy</a></li>
        <li><a href="/contact-us"><MdNavigateNext className="navigate-icon"/> Contact Us</a></li>

      </ul>
    </div>
   <div className="footer-col">
  <h4>Contact</h4>

  <p>
    <a href="mailto:mateltradingmotors@gmail.com">
      <MdOutlineEmail className="footer__contact-icon" />
      mateltradingmotors@gmail.com
    </a>
  </p>

  <p>
    <a href="tel:+254713988888">
      <MdLocalPhone className="footer__contact-icon" />
      +254 713 988 888
    </a>
  </p>

  <p>
    <a
      href="https://maps.app.goo.gl/5dssv5Es97rcvyau9"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IoLocationSharp className="footer__contact-icon" />
      Ridgeways, Next to Runda Mall
    </a>
  </p>

  <div className="footer__social-wrapper">
    <p>Follow for updates:</p>

    <div className="footer__social-icons d-flex align-items-center">
      <a
        href="https://www.instagram.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram className="footer__social-icon" />
      </a>

      <a
        href="https://x.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaXTwitter className="footer__social-icon" />
      </a>

      <a
        href="https://www.facebook.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaFacebook className="footer__social-icon" />
      </a>
    </div>
  </div>
</div>
  </div>

  {/* Bottom Section */}
  <div className="footer-bottom-element">
    <p>© {new Date().getFullYear()} Car Dealer. All rights reserved.</p>
      <div className="footer-trademark">
    <a
      href="https://roarzkreatives.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Roarz Kreatives"
    >
      A <span>Roarz Kreatives</span> Production
    </a>
  </div>
  </div>
</footer>


    </>
  );
  };

export default Footer;
